export default {"src":"/_next/static/media/ico_store.3b548757.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};